import { units } from '@ui/css';
import { makeSelectors, combineTokens } from '@utils/css';
import { makeSizeTokens } from '@utils/react/selectors';

const actionsSize = makeSizeTokens("--actions", units.px(101));
combineTokens("--i-guide", {
  paddingInline: 0,
  paddingBlock: 0
});
const root = "_uxsrr9509o";
const wrapper = "_uxswyohp2t";
const titleWrapper = "_uxstypu63i";
const contextMenu = "_uxsc1bygk1e";
const saveIndicatorPlaceholder = "_uxss8tj5gi";
const saveIndicatorWrapper = "_uxss1obegm9";
const saveIndicator = "_uxsszt4js8";
const actionsWrapper = "_uxsa1xbmzrl";
const elementToolbarPlaceholder = "_uxse8kjyv4";
const actions = "_uxsaive6ql";
const componentWrapper = "_uxsckph4xr";
const tabList = "_uxst4rd80a";
const speechButtonWrapper = "_uxss61i3y5";
const speechButtonSticky = "_uxss1jd4lhq";
const selectors = makeSelectors({
  wrapper,
  titleWrapper
});

export { actions, actionsSize, actionsWrapper, componentWrapper, contextMenu, elementToolbarPlaceholder, root, saveIndicator, saveIndicatorPlaceholder, saveIndicatorWrapper, selectors, speechButtonSticky, speechButtonWrapper, tabList, titleWrapper, wrapper };
import "./_component.style.linaria.module.css";
//# sourceMappingURL=_component.style.js.map
